import React, { useState } from 'react'

import { Modal } from '@clientbase/clientbase-library'
import { useActiveMerchantForRecord } from 'lib/merchant-group'
import { ChargeRecurrenceBodyModalForm } from 'templates/Charge/interface'

import ModalNewCharge from 'components/Modal/ModalNewCharge'

import { ModalChargeDetailProvider } from './context'
import ModalChargeDetailBody from './ModalChargeDetailBody'

type ModalChargeDetailProps = {
  uuid: string
  handleCloseChargeDetail: (reloadTable?: boolean) => void
  isOpenChargeDetail: boolean

  zIndex?: number
  disablePortal?: boolean
  setReloadTable?: React.Dispatch<React.SetStateAction<boolean>>
}

const ModalChargeDetail = ({
  uuid,
  handleCloseChargeDetail,
  isOpenChargeDetail,
  setReloadTable
}: ModalChargeDetailProps) => {
  // SC-10999: aberto da lista agregada do grupo, age na empresa do registro
  // (o detalhe, as ações e a duplicação vão com o token dela).
  useActiveMerchantForRecord(isOpenChargeDetail ? uuid : undefined)

  // O modal de duplicação vive aqui, e não na página, porque o ModalChargeDetail
  // é aberto de ~25 lugares — a maioria sem ChargeContext por perto. Ver
  // handleDuplicate em ./components/PayerActions.
  const [duplicateValues, setDuplicateValues] =
    useState<Partial<ChargeRecurrenceBodyModalForm>>()

  const isDuplicating = Boolean(duplicateValues)

  const handleCloseDuplicate = (reloadTable = false) => {
    setDuplicateValues(undefined)
    handleCloseChargeDetail(reloadTable)
  }

  return (
    <React.Fragment>
      {/* `90vh` fixo, e não o antigo `calc(100%-200px)`: sem espaços em
            volta do `-` a regra é inválida e o browser a descartava, deixando
            a altura por conta do conteúdo — o modal abria curto no esqueleto e
            crescia quando os dados chegavam. */}
      <Modal
        disablePortal={false}
        handleClose={() => handleCloseChargeDetail(false)}
        open={isOpenChargeDetail && !isDuplicating}
        maxWidth="1150px"
        width="100%"
        height="90vh"
        maxHeight="90vh"
      >
        <ModalChargeDetailProvider
          onClose={handleCloseChargeDetail}
          onDuplicate={setDuplicateValues}
        >
          <ModalChargeDetailBody
            setReloadTable={setReloadTable}
            onClose={(v) => handleCloseChargeDetail(v)}
            uuid={uuid}
          />
        </ModalChargeDetailProvider>
      </Modal>

      {isDuplicating && (
        <ModalNewCharge
          isOpenModalNewCharge
          defaultValues={duplicateValues}
          isDuplicate
          handleCloseModal={() => handleCloseDuplicate()}
          onClose={(refresh) => handleCloseDuplicate(refresh)}
          revalidateTable={() => setReloadTable?.((prev) => !prev)}
        />
      )}
    </React.Fragment>
  )
}

export default ModalChargeDetail
